export default __webpack_public_path__ + "static/media/result-weight.767fcf40.svg";